<template>
    <div class="customModal display_center" v-if="showmodal">
        <slot name="content"></slot>
        <div class="main" :style="style" v-if="content">
            <div class="text_right">
                <img src="/image/qkxy/closemodal.png" alt="" class="close" @click="close">
            </div>
            <div>
                <slot></slot>
            </div>
        </div>

    </div>
</template>

<script>
    var preD = function (e) {
        e.preventDefault()
    }
    export default {
        name: "customModal",
        props:{
            showmodal:{
                type:Boolean
            },
            width:{
                type:String,
                default:"500px"
            },
            content:{
                type:Boolean,
                default:true
            }
        },
        computed: {
            style() {
                let style = {};
                style.width = this.width;
                return style;
            }
        },
        watch:{
            showmodal(newValue){
                if(newValue){
                    document.body.style.overflow = 'hidden'
                    document.addEventListener('touchmove', preD, {passive: false})
                }else{
                    document.body.style.overflow = '' // 出现滚动条
                    document.removeEventListener('touchmove', preD, {passive: false})
                }
            }
        },
        beforeDestroy(){
            document.body.style.overflow = '' // 出现滚动条
            document.removeEventListener('touchmove', preD, {passive: false})
        },
        methods:{
            close(){
                this.$emit('update:showmodal', false);
            }
        }

    }
</script>

<style scoped>
    .customModal{
        position: fixed;
        background: rgba(0,0,0,0.2);
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        z-index: 1000;
    }
    .main{
        padding: 20px;
        background: #fff;
        padding-bottom: 40px;
        box-sizing: border-box;
    }
    .close{
        cursor: pointer;
    }
</style>
